var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftEdgeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 161.8,
    cy: 68.9,
    r: 95.4,
    gradientTransform: "matrix(1 0 0 -.95 0 248.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: -340.3,
    cy: 63,
    r: 143.2,
    gradientTransform: "matrix(.15 -.99 -.8 -.12 176.6 -125.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 113.4,
    cy: 570.2,
    r: 202.4,
    gradientTransform: "matrix(-.04 1 2.13 .08 -1179.5 -106.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35c1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#34c1ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2fc2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2bc3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#36c752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 376.5,
    cy: 568,
    r: 97.3,
    gradientTransform: "matrix(.28 .96 .78 -.23 -303.8 -148.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66eb6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66eb6e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 63.3,
    y1: 84,
    x2: 241.7,
    y2: 84,
    gradientTransform: "matrix(1 0 0 -1 0 266)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c59a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114a8b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 157.3,
    y1: 161.4,
    x2: 46,
    y2: 40.1,
    gradientTransform: "matrix(1 0 0 -1 0 266)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b9de2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1595df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0680d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M235.7 195.5a93.7 93.7 0 0 1-10.6 4.7 101.9 101.9 0 0 1-35.9 6.4c-47.3 0-88.5-32.5-88.5-74.3a31.5 31.5 0 0 1 16.4-27.3c-42.8 1.8-53.8 46.4-53.8 72.5 0 74 68.1 81.4 82.8 81.4 7.9 0 19.8-2.3 27-4.6l1.3-.4a128.3 128.3 0 0 0 66.6-52.8 4 4 0 0 0-5.3-5.6Z",
    transform: "translate(-4.6 -5)",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.7 195.5a93.7 93.7 0 0 1-10.6 4.7 101.9 101.9 0 0 1-35.9 6.4c-47.3 0-88.5-32.5-88.5-74.3a31.5 31.5 0 0 1 16.4-27.3c-42.8 1.8-53.8 46.4-53.8 72.5 0 74 68.1 81.4 82.8 81.4 7.9 0 19.8-2.3 27-4.6l1.3-.4a128.3 128.3 0 0 0 66.6-52.8 4 4 0 0 0-5.3-5.6Z",
    transform: "translate(-4.6 -5)",
    style: {
      isolation: "isolate",
      opacity: 0.35,
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.3 246.3A79.2 79.2 0 0 1 87.6 225a80.7 80.7 0 0 1 29.5-120c3.2-1.5 8.5-4.1 15.6-4a32.4 32.4 0 0 1 25.7 13 31.9 31.9 0 0 1 6.3 18.7c0-.2 24.5-79.6-80-79.6-43.9 0-80 41.6-80 78.2a130.2 130.2 0 0 0 12.1 56 128 128 0 0 0 156.4 67 75.5 75.5 0 0 1-62.8-8Z",
    transform: "translate(-4.6 -5)",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.3 246.3A79.2 79.2 0 0 1 87.6 225a80.7 80.7 0 0 1 29.5-120c3.2-1.5 8.5-4.1 15.6-4a32.4 32.4 0 0 1 25.7 13 31.9 31.9 0 0 1 6.3 18.7c0-.2 24.5-79.6-80-79.6-43.9 0-80 41.6-80 78.2a130.2 130.2 0 0 0 12.1 56 128 128 0 0 0 156.4 67 75.5 75.5 0 0 1-62.8-8Z",
    transform: "translate(-4.6 -5)",
    style: {
      opacity: 0.41,
      fill: "url(#d)",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 153.8c-.9 1-3.4 2.5-3.4 5.6 0 2.6 1.7 5.2 4.8 7.3 14.3 10 41.4 8.6 41.5 8.6a59.6 59.6 0 0 0 30.3-8.3 61.4 61.4 0 0 0 30.4-52.9c.3-22.4-8-37.3-11.3-43.9C228 28.8 182.3 5 132.6 5a128 128 0 0 0-128 126.2c.5-36.5 36.8-66 80-66 3.5 0 23.5.3 42 10a72.6 72.6 0 0 1 30.9 29.3c6.1 10.6 7.2 24.1 7.2 29.5s-2.7 13.3-7.8 19.9Z",
    transform: "translate(-4.6 -5)",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 153.8c-.9 1-3.4 2.5-3.4 5.6 0 2.6 1.7 5.2 4.8 7.3 14.3 10 41.4 8.6 41.5 8.6a59.6 59.6 0 0 0 30.3-8.3 61.4 61.4 0 0 0 30.4-52.9c.3-22.4-8-37.3-11.3-43.9C228 28.8 182.3 5 132.6 5a128 128 0 0 0-128 126.2c.5-36.5 36.8-66 80-66 3.5 0 23.5.3 42 10a72.6 72.6 0 0 1 30.9 29.3c6.1 10.6 7.2 24.1 7.2 29.5s-2.7 13.3-7.8 19.9Z",
    transform: "translate(-4.6 -5)",
    style: {
      fill: "url(#f)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftEdgeLogo);
export default __webpack_public_path__ + "static/media/microsoft-edge-logo.a35bbf6f874dbaa5755eb3b1ee116f74.svg";
export { ForwardRef as ReactComponent };